import { Stack, Typography } from '@mui/material';

import { CloseButton } from '@/ui/components/button/CloseButton';
import { QuizPanelLayout } from '@/ui/components/quiz-panel/QuizPanelLayout';
import { language } from '@/ui/i18n';
import { QuizFormSeparator } from '@/ui/pages/app/components/quiz-panel/co2/components/QuizFormSeparator';

import { Co2MonthQuiz } from './co2-month-quiz/Co2MonthQuiz';

export function MonthQuizPanel({
  monthDate,
  onClose,
}: {
  monthDate: string;
  onClose: () => void;
}) {
  return (
    <QuizPanelLayout panelOpen={true} setPanelOpen={onClose}>
      <Stack sx={{ gap: 2 }}>
        <Title monthDate={monthDate} onClose={onClose} />
        <QuizFormSeparator label={'CO2'} />
        <Co2MonthQuiz month={monthDate} />
      </Stack>
    </QuizPanelLayout>
  );
}

function Title({
  monthDate,
  onClose,
}: {
  monthDate: string;
  onClose: () => void;
}) {
  const title = new Date(monthDate).toLocaleDateString(language, {
    month: 'long',
    year: '2-digit',
  });
  return (
    <Stack direction={'row'}>
      <CloseButton sx={{ mr: 1, ml: -2 }} onClick={onClose} />
      <Typography variant="h6" sx={{ textTransform: 'capitalize' }}>
        {title}
      </Typography>
    </Stack>
  );
}
